
import ChooseCategory from "../components/CreateAuctionListingForm/ChooseCategory";
import CreateBuyListForm from "../components/CarsBikesBusCustomFiledForm/CreateBuyListForm"
import Container from "../components/layout/Container";
import FilterHeader from "../components/Shared/FilterHeader/FilterHeader";
import MyAccount from "../components/Shared/MyAccount/MyAccount";

const CreateBuyListingForm = () => {
  return (
    <Container>
      <div className="flex items-start justify-between gap-x-6">
        <MyAccount />
        <div className="grow">
          <FilterHeader
            title={"Creating Buy Listing"}
            dropdown={false}
            className="mt-[60px]"
          />
          <ChooseCategory/>
          <CreateBuyListForm />
        </div>
      </div>
    </Container>
  );
};

export default CreateBuyListingForm;
